import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { wordCountSelector } from '@chegg-wt/core-wa/state/selectors'
import { emitNotificationEvent } from '@chegg-wt/core/state/instrumentation/actions'
import {
  EDITOR_FOOTER_TEST_ID,
  EDITOR_WORD_LIMIT,
  WORDS,
} from '@chegg-wt/core-wa/constants/paraphraser'
import { WordsExceededInfoTooltip } from '../InfoTooltip'
import { CountContainer, EditorFooterContainer, FooterBar, WordCount } from './styled'
import { EditorMainToolbar } from './EditorMainToolbar'

const EditorFooter = () => {
  const editorTextWordCount = useSelector(wordCountSelector)
  const isWordsLimitExceeded = editorTextWordCount >= EDITOR_WORD_LIMIT
  const dispatch = useDispatch()

  useEffect(() => {
    if (isWordsLimitExceeded) {
      dispatch(
        emitNotificationEvent({
          type: 'warning',
          message_name: 'reached word limit',
          message_detail: 'exceeded 2500 words',
        })
      )
    }
  }, [dispatch, isWordsLimitExceeded])

  return (
    <EditorFooterContainer data-test={`${EDITOR_FOOTER_TEST_ID}`}>
      {isWordsLimitExceeded && <WordsExceededInfoTooltip />}
      <FooterBar>
        <EditorMainToolbar />
        <CountContainer>
          <WordCount data-test={`${EDITOR_FOOTER_TEST_ID}-wordcount`}>
            {editorTextWordCount} {WORDS}
          </WordCount>
        </CountContainer>
      </FooterBar>
    </EditorFooterContainer>
  )
}

export default EditorFooter
